// NEW_FILE_JUSTIFIED: New route page for org owner policy stats — no existing equivalent
import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: convex _generated
import { useOrgContext } from '@/hooks/useOrgContext';
import { StatCard } from '@/components/dashboard/StatCard';
import { PolicyBreakdownTable } from '@/components/control/PolicyBreakdownTable';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export function OrgPolicyStatsPage() {
  const { currentOrg, isLoading: orgLoading } = useOrgContext();

  const policyStats = useQuery(
    api.superadmin.orgOwnerQueries.getOrgPolicyStats,
    currentOrg ? { orgId: currentOrg._id } : 'skip'
  );
  const templates = useQuery(
    api.superadmin.orgOwnerQueries.getOrgAvailableTemplates,
    currentOrg ? { orgId: currentOrg._id } : 'skip'
  );

  const isLoading = orgLoading || policyStats === undefined;

  return (
    <div className="flex flex-col gap-6 p-6">
      <h1 className="text-2xl font-semibold text-foreground">
        Policy Statistics {currentOrg && `— ${currentOrg.name}`}
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard
          label="Total Policies"
          value={policyStats?.totalPolicies}
          subtitle="All statuses"
        />
        <StatCard
          label="Active Policies"
          value={policyStats?.activePolicies}
          subtitle="Currently active"
        />
        <StatCard
          label="Available Templates"
          value={templates?.length}
          subtitle="Assigned to your org"
        />
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Policy Breakdown by Type & Provider</CardTitle>
        </CardHeader>
        <CardContent>
          <PolicyBreakdownTable breakdown={policyStats?.breakdown} isLoading={isLoading} />
        </CardContent>
      </Card>

      {templates && templates.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle className="text-lg">Available Policy Templates</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              {templates.map(template => (
                <div
                  key={template._id}
                  className="flex items-center justify-between py-2 px-3 border border-border rounded-lg"
                >
                  <div>
                    <span className="font-medium text-sm">{template.name}</span>
                    <span className="text-xs text-muted-foreground ml-2">
                      {template.policyTypeName}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge variant="outline" className="text-xs">
                      {template.providerName}
                    </Badge>
                    <span className="text-xs text-muted-foreground">
                      {template.fieldsCount} fields
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
